import React from 'react';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import './contact_support.less';
import {Link} from 'react-router';
import ProfileNavBar from './profile_navbar/profile_navbar';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import './promocode.less';
import profileActions from './profile_actions';
import validate from '../util/validate';
import ShowError from '../components/error/show_error';
import {join} from '../util/common';
import SuccessMessage from '../components/success/success_msg';
import CONSTANTS from '../common_constants';

class PromoCode extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
        this.applyPromocode = this.applyPromocode.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.state = {
            promoCodeId: '',
            ajaxInProgress: false,
            validationError: '',
            error: ''
        }
    }

    inputChange(name, event){
        const stateObj = {};
        stateObj[name] = event.target.value;
        this.setState(stateObj);
    }

    logout(){
     this.props.authActions.logout().always(() => {
          cookies.delete('_sd');
          document.location.href = '/';
      });
    }

    applyPromocode() {
        const {props, state} = this;
        let params = {promoCodeId: state.promoCodeId};
        let {profileActions} = props;
        let validationErrorMsg = '';
        let {promoCodeId} = state;
        const {userData} = props.authState;

        const validationError = {
            promoCodeId: !validate.promocode(promoCodeId)
        };
        const validationMap = {
            promoCodeId: 'Promocode'
        };
        const validationFields = [];

        Object.keys(validationError).forEach((key) => {
            if (validationError[key]) {
                validationFields.push(validationMap[key]);
            }
        });

        if (validationFields.length) {
            validationErrorMsg = 'Please enter the ' + join(validationFields, (item, idx) => {
                if (validationFields.length === 1)
                    return "";
                if (idx > 0 && idx < validationFields.length - 1)
                    return ", ";
                else if (idx === validationFields.length - 1)
                    return " and ";
                return "";
            }) + '.';
        }

        if (validationErrorMsg) {
            this.setState({error: validationErrorMsg});
            return;
        }

        this.setState({ajaxInProgress: true});

        profileActions.addPromoCode(params).then((data) => {
          if(userData.email) amplitude.getInstance().setUserId(userData.email);
          amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.USER_ADDED_PROMOCODE);
            window.scrollTo(0, 0);
            this.setState({ajaxInProgress:  false,
              error: '',
              success: 'Promocode successfully applied'
           });
           setTimeout(() => {
            this.setState({
              success: '',
              promoCodeId: ''
            });
            this.refs.promoCodeId.value = '';
           }, 3000)
        }, (error) => {
            window.scrollTo(0, 0);
            this.setState({ajaxInProgress: false});
            this.setState({error: error.error});
            setTimeout( () => {
            this.setState({error: ''});
          }, 3000)
        })
    }

    render() {
       const {props, state} = this;
       const {userData} = props.authState;
       let {error} = state;
       let {success} = state;
       let {ajaxInProgress} = state;
        let user = {
         name: '',
         imageUrl: '',
         isVerified: '',
         creditAmount: ''
       };
       const loader = <div className="loader"></div>;

       if(props.authState) {
         user.name = userData.name;
         user.imageUrl = userData.profileImageUrl;
         user.isVerified = userData.isVerified;
         user.creditAmount = userData.creditAmount
       }
        return (
            <div className="profile-details-wrap">
              <DashBoardHeader user={user} logout={this.logout} />
              <div className="profile-header-wrap">
                <div className="wrapper">
                  <h2 className="page-header profile-page-header">Account</h2>
                </div>
              </div>
              <div className="promocode-section-wrap">
                <div className="wrapper" id="promocodeSectionWrap">
                  <div className="profile-navbar-wrap">
                    <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                  </div>
                  <div className="promocode-wrapper">
                    {state.error && <ShowError errorMessage = {error} />}
                    {state.success && <SuccessMessage successMessage = {success} />}
                    <div className="promocode-elements-wrap">
                      <div id="promocodeHeaderWrap">Add Promo code</div>
                      <div className="promocode-ui-elm-wrap">
                        <div className="promocode-elm">
                            <input ref="promoCodeId" placeholder="Promo code" onChange={this.inputChange.bind(self, 'promoCodeId')} />
                        </div>
                        <div className="promocode-elm">
                            <button id="promoCodeBtn" onClick={this.applyPromocode} className="btn orange">{ajaxInProgress ? loader: 'Apply'}
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <LoggedinFooter />
            </div>
        )
    }
}

PromoCode = connect((state) => {
  return {
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch)
  }
})(PromoCode);

export default PromoCode;



// WEBPACK FOOTER //
// app/profile/promocode.jsx